'use strict';
/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = require('../internals/symbol-constructor-detection');

module.exports = NATIVE_SYMBOL &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/use-symbol-as-uid.js
// module id = 137
// module chunks = 22